import { baseAPI } from './index';

export interface postRecentSearchAPIProps {
  name: string;
  IPFSHash: string;
  previewURL: string;
  prefferedGateway: string;
}

export const postRecentSearchAPI = async ({
  name,
  IPFSHash,
  previewURL,
  prefferedGateway,
}: postRecentSearchAPIProps) => {
  const body = {
    name,
    ipfsHash: IPFSHash,
    previewURL,
    prefferedGateway,
  };
  return baseAPI.post(`/ipfs/search`, body);
};
